<template>
    <SdsTable></SdsTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SdsTable = defineAsyncComponent(() =>
    import("../../components/Safety/SDSTable/SDSTable.vue")
);

export default {
    name: "SDS_Table", //The name you are in should not equal the name of the component you are importing.
    components: { SdsTable, AuthLayout },
};
</script>
